import React from 'react';
import { Template } from '~/interfaces/Template';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '../ui/tooltip';
import { Button } from '../ui/button';
import TagTooltipMinusIcon from '../icons/TagTooltipMinusIcon';
import TagTooltipPlusIcon from '../icons/TagTooltipPlusIcon';

export default function Tags({ template }: { template: Template }) {
  const [open, setOpen] = React.useState(false);

  return (
    <div className="relative mt-2">
      <ul className="flex h-8 items-center justify-start gap-x-1 overflow-x-hidden">
        {template.tags.map((tag) => (
          <li
            className="bg-taupe-light-20 min-w-fit rounded-3xl border border-brown-dark px-2 py-[2px] text-[11px] font-bold uppercase text-brown-dark"
            key={tag.tagTitle}
          >
            {tag.tagTitle}
          </li>
        ))}
      </ul>
      <div className="absolute right-0 top-0 flex h-8 w-8 items-center justify-end bg-gradient-to-l from-beige-pale from-55% to-transparent">
        <TooltipProvider delayDuration={300}>
          <Tooltip open={open} onOpenChange={(newOpen) => setOpen(newOpen)}>
            <TooltipTrigger asChild>
              <Button type="button" className="cursor-pointer p-2 pr-0" onClick={() => setOpen(!open)}>
                {open ? <TagTooltipMinusIcon /> : <TagTooltipPlusIcon />}
              </Button>
            </TooltipTrigger>
            <TooltipContent className="w-52 bg-green-pale p-4 text-sm font-normal text-brown-dark">
              <p className="pb-1 font-bold">{template.name}</p>
              <ul className="list-square list-outside pl-4">
                {template.tags.map((tagObj) => (
                  <li className="indent-0" key={`tooltip__${tagObj.tagTitle}`}>
                    {tagObj.tagTitle}
                  </li>
                ))}
              </ul>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
    </div>
  );
}
